import { Phone } from "lucide-react";
import { BRAND } from "@/lib/site";

export default function StickyMobileCall() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 md:hidden"
      data-testid="mobile-sticky-cta"
    >
      <div className="grid grid-cols-2 gap-0 border-t border-slate-200 bg-white">
        <a
          href={BRAND.phoneTel}
          data-testid="mobile-call-now-btn"
          className="flex items-center justify-center gap-2 bg-blue-600 px-4 py-4 text-base font-bold text-white active:bg-blue-700"
        >
          <Phone className="h-5 w-5" />
          Call Now
        </a>
        <a
          href="/contact#quote"
          data-testid="mobile-get-quote-btn"
          className="flex items-center justify-center gap-2 bg-yellow-400 px-4 py-4 text-base font-bold text-slate-900 active:bg-yellow-500"
        >
          Get Free Quote
        </a>
      </div>
    </div>
  );
}
